export default __webpack_public_path__ + "658d9fcf295b9693f376d46493571e50.svg";